import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "font-medium text-sm text-gray-900" };
const _hoisted_2 = {
    key: 0,
    class: "flex justify-center min-w-[170px] min-h-[170px] px-4 py-1.75"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { class: "p-2 border-b border-gray-300 sticky top-0 bg-white grid w-full max-w-lg z-[1000]" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["Combobox"], {
            modelValue: $setup.selectedOptions,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.selectedOptions) = $event)),
            by: $props.by,
            multiple: $props.multiple,
            disabled: $props.disabled,
            nullable: ""
        }, {
            default: _withCtx(({ open }) => [
                _createVNode($setup["ComboboxButton"], {
                    class: "inline-flex w-full items-center gap-x-1 rounded-md bg-white px-2.5 py-1.5 text-sm text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                    ref: "comboboxButton"
                }, {
                    default: _withCtx(() => [
                        _createVNode($setup["XMarkIcon"], {
                            class: _normalizeClass(["-ml-1 size-2 text-gray-400 mt-[2px]", { hidden: !$setup.selectedOptions }]),
                            "aria-hidden": "true",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {
                                let newQuery = { ...$setup.route.query };
                                delete newQuery[$props.filterKey];
                                if ($props.pagination) {
                                    newQuery = {
                                        ...newQuery,
                                        ...{
                                            startIndex: 1,
                                        },
                                    };
                                }
                                $setup.router.push({
                                    query: newQuery,
                                });
                            }, ["prevent"]))
                        }, null, 8 /* PROPS */, ["class"]),
                        _createElementVNode("span", _hoisted_1, [
                            ($props.multiple)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString($setup.selectedOptions.map(({ label }) => label).join(', ') || $props.placeholder), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString($setup.selectedOptions?.label || $props.placeholder), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                        ]),
                        _createVNode($setup["ChevronDownIcon"], {
                            class: "ml-auto -mr-1 size-2 text-gray-400",
                            "aria-hidden": "true"
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */),
                _createVNode(_Transition, {
                    onBeforeEnter: $setup.onOpen,
                    onAfterLeave: $setup.onClose,
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                }, {
                    default: _withCtx(() => [
                        _createVNode($setup["ComboboxOptions"], { class: "absolute mt-2 overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10 max-h-[465px] overflow-y-auto" }, {
                            default: _withCtx(() => [
                                ($setup.ajaxIsLoading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode($setup["LoadingSpinner"], { size: 32 })
                                    ]))
                                    : ($setup.ajaxError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.$t(`Something went wrong. Please try again later.`)), 1 /* TEXT */))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode($setup["ComboboxInput"], {
                                                    class: "min-w-[170px] col-start-1 row-start-1 block w-full rounded-md bg-white py-1.25 pl-5 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-mertl-blue sm:text-sm",
                                                    placeholder: $props.searchPlaceholder,
                                                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                                                    onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
                                                    onInput: $setup.onInput
                                                }, null, 8 /* PROPS */, ["placeholder"]),
                                                _createVNode($setup["MagnifyingGlassIcon"], {
                                                    class: "pointer-events-none col-start-1 row-start-1 ml-1.5 size-2 self-center text-gray-400",
                                                    "aria-hidden": "true"
                                                })
                                            ]),
                                            (_openBlock(), _createBlock($setup["ComboboxOption"], {
                                                key: '',
                                                value: ''
                                            })),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredOptions, (option) => {
                                                return (_openBlock(), _createBlock($setup["ComboboxOption"], {
                                                    key: option.key,
                                                    value: option
                                                }, {
                                                    default: _withCtx(({ selected }) => [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass([
                                                                selected
                                                                    ? 'bg-gray-100 text-gray-900 forced-color-adjust-none  forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
                                                                    : 'text-gray-700 hover:bg-gray-50 hover:cursor-pointer',
                                                                'block p-2 gap-1 text-sm font-semibold',
                                                            ])
                                                        }, _toDisplayString(option.label), 3 /* TEXT, CLASS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "by", "multiple", "disabled"])
    ]));
}
